export default __webpack_public_path__ + "static/media/rightnowsmall.9273ae6b.jpg";